var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconCheckV2 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00118 10.359C5.69786 10.6415 5.20635 10.6414 4.90317 10.3588L2.68538 8.29168C2.38286 8.00971 1.89264 8.0089 1.58905 8.28987L1.56274 8.31423C1.25763 8.5966 1.25676 9.05629 1.56079 9.33967L4.90291 12.4547C5.20619 12.7374 5.6979 12.7374 6.00118 12.4547L14.4392 4.58999C14.7425 4.30733 14.7425 3.84903 14.4392 3.56636L14.4167 3.54538C14.1135 3.2628 13.622 3.26269 13.3187 3.54514L6.00118 10.359Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconCheckV2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-check-v2.2ad403668636a0d97cdffca6d15aabc3.svg";